import ErrorHandlingForm from "../../../components/formValidation/ErrorHandlingFrom";
import {
    validateNonNegativeNumber,
    validateNumber,
    validateRequired
} from "../../../components/formValidation/validators";
import Stack from "@mui/material/Stack";
import CustomTextField from "../../../components/formValidation/CustomTextField";
import React, {useState} from "react";
import {FormControl, InputAdornment, InputLabel, MenuItem} from "@mui/material";
import CustomSelect from "../../../components/formValidation/CustomSelect";
import {currencies, invoiceTypes} from "../../../utils/enums";

const FinancialData = ({reference, data, setData}) => {
    const [errors, setErrors] = useState({
        invoice_number: false,
        agreed_price: false,
        invoice: false,
        currency: false,
        payed_amount: false,
    })

    const validators = {
        invoice_number: [],
        agreed_price: [validateNonNegativeNumber],
        invoice: [],
        currency: [validateRequired],
        payed_amount: [validateNumber, validateNonNegativeNumber]
    }

    return <ErrorHandlingForm
        data={data}
        setData={setData}
        errors={errors}
        setErrors={setErrors}
        validators={validators}
        reference={reference}
    >
        <Stack spacing={1}>
            <CustomTextField
                name="invoice_number"
                label="Számlaszám"
                data={data}
                setData={setData}
                errors={errors}
                setErrors={setErrors}
                validators={validators}
            />
            <CustomTextField
                name="agreed_price"
                label="Megegyezett ár"
                data={data}
                setData={setData}
                errors={errors}
                setErrors={setErrors}
                validators={validators}
                InputProps={{
                    endAdornment: <InputAdornment position="end">{data?.currency}</InputAdornment>,
                }}
            />

            <CustomTextField
                name="payed_amount"
                label="Kifizetett összeg"
                data={data}
                setData={setData}
                errors={errors}
                setErrors={setErrors}
                validators={validators}
                InputProps={{
                    endAdornment: <InputAdornment position="end">{data?.currency}</InputAdornment>,
                }}
            />


            <FormControl>
                <InputLabel id="invoice-type">Fizetési mód</InputLabel>
                <CustomSelect
                    labelId="invoice-type"
                    label="Számla típusa"
                    id="invoice"
                    name="invoice"
                    data={data}
                    setData={setData}
                    errors={errors}
                    setErrors={setErrors}
                    validators={validators}
                >
                    <MenuItem value=''>-</MenuItem>
                    {Object.entries(invoiceTypes).map(([key, value]) => <MenuItem key={key}
                                                                                  value={value}>{value}</MenuItem>)}
                </CustomSelect>
            </FormControl>


            <FormControl>
                <InputLabel id="currency-types">Valuta</InputLabel>
                <CustomSelect
                    labelId="currency-types"
                    label="Valuta"
                    id="currency"
                    name="currency"
                    data={data}
                    setData={setData}
                    errors={errors}
                    setErrors={setErrors}
                    validators={validators}
                >
                    {Object.entries(currencies).map(([key, value]) => <MenuItem
                        key={key}
                        value={value}
                    >
                        {value}
                    </MenuItem>)}
                </CustomSelect>

            </FormControl>
        </Stack>
    </ErrorHandlingForm>
}

export default FinancialData